import { getCoreRowModel, useReactTable, type ColumnDef } from "@tanstack/react-table";

interface UsePortfolioPositionsTableArgs<TData> {
    data: TData[];
    columns: ColumnDef<TData, unknown>[];
    isLoading: boolean;
}

export const usePortfolioPositionsTable = <TData>({
    data,
    columns,
    isLoading,
}: UsePortfolioPositionsTableArgs<TData>) => {
    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return {
        isLoading,
        table,
        rowModel: table.getRowModel(),
    };
};
